// Text
export var text = {
  t1: "0.625rem",
  t2: "0.6875rem",
  t3: "0.75rem",
  t4: "0.8125rem",
  t5: "0.875rem",
  t6: "0.9375rem",
  t7: "1rem",
  t8: "1.125rem",
  t9: "2rem"
};